<div *ngIf="menuItens && menuItens.length !== 0" class="po-holder">
  <p class="texto">Mais acessados</p>
  <div class="po-row">
    <div *ngIf="isSmallScreen(); else mediumOrLargeScreenItems" style="width: 100%;">
      <div
        *ngFor="let menuItem of menuItens.slice(0, 3)"
        class="po-sm-4 po-md-4"
      >
        <po-container [p-height]="150" class="item-container">
          <div class="icon-row">
            <span (click)="navigateToPage(menuItem.link)" class="card-featured-icon po-icon {{ menuItem.icon }}"></span>
          </div>
          <div class="text-row">
            <span (click)="navigateToPage(menuItem.link)" class="mouse-pointer">
              {{ menuItem.componentDescription }}
            </span>
          </div>
        </po-container>
      </div>
    </div>
    <ng-template #mediumOrLargeScreenItems>
      <div *ngIf="isMediumScreen(); else largeScreenItems" style="width: 100%;">
        <div
          *ngFor="let menuItem of menuItens.slice(0, 4)"
          class="po-sm-4 po-md-3"
        >
          <po-container [p-height]="120" class="item-container">
            <div class="icon-row">
              <span (click)="navigateToPage(menuItem.link)" class="card-featured-icon po-icon {{ menuItem.icon }}"></span>
            </div>
            <div class="text-row">
              <span (click)="navigateToPage(menuItem.link)" class="mouse-pointer">
                {{ menuItem.componentDescription }}
              </span>
            </div>
          </po-container>
        </div>
      </div>
      <ng-template #largeScreenItems>
        <div
          *ngFor="let menuItem of menuItens.slice(0, 6)"
          class="po-sm-4 po-md-3 po-lg-2 po-xl-2"
        >
          <po-container [p-height]="120" class="item-container">
            <div class="icon-row">
              <span (click)="navigateToPage(menuItem.link)" class="card-featured-icon po-icon {{ menuItem.icon }}"></span>
            </div>
            <div class="text-row">
              <span (click)="navigateToPage(menuItem.link)" class="mouse-pointer">
                {{ menuItem.componentDescription }}
              </span>
            </div>
          </po-container>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
